// #region Composables
import {useTitle} from '@vueuse/core';
import store from '@/pages/_root/store';
// #endregion

// #region Enums
import {
  modeRegisterEnum,
} from '@/enum/registers.enum';
// #endregion

export default [
  async function addTitleRouteToTitlePage(to, from, next) {
    const titleRef = useTitle(document.title);
    if (to.meta.title) {
      const portalType = STTEDRA_TYPE_PORTAL;
      titleRef.value = `${to.meta.title} - ${portalType === 'verano-joven' ? 'Verano Joven' : 'Código Viajero'}`;
    }
    next();
  },
  function checkRouteTutorizeRedirect(to, from, next) {
    const portalType = STTEDRA_TYPE_PORTAL;
    if (portalType === 'verano-joven') {
      return next();
    }
    if (to.name === 'Register') {
      store.commit('register/SET_MODE_REGISTER', modeRegisterEnum.DEFAULT);
    }
    if (to.name === 'RegisterTutorize') {
      store.commit('register/SET_MODE_REGISTER', modeRegisterEnum.TUTORIZE);
    }
    next();
  },
];
